import { Route, Routes, useLocation } from 'react-router-dom';
import React from 'react';
import Navbar from './Frontend/Navbar/Navbar';
import './App.css';
import Login from './Frontend/Login/Login';
import Signup from './Frontend/Signup/Signup';
import AdminDashboard from './Frontend/AdminDashboard/AdminDashboard';
import CouponManagement from './Frontend/AdminDashboard/CouponManagement';
import SelectQuestionPage from './Frontend/SelectQuestion/SelectQuestionPage';
import FreeAssesment from './Frontend/FreeAssesment/FreeAssesment';
import TestAssesmentBooks from './Frontend/FreeAssesment/TestAssesmentBooks';
import QuestionPage from './Frontend/FreeAssesment/QuestionPage';
import GenerateQuestionPage from './Frontend/GenerateQuestion/GenerateQuestionPage';
import FreeAssessment from './Frontend/FreeAssessment/FreeAssessment';
import ProtectedRoute from './Frontend/Context/ProtectedRoute';
import ViewQuestionsPage from './Frontend/view/ViewQuestionsPage';
import LandingPage from './Frontend/LandingPage/LandingPage';
import ReadingGenerateQuestions from './Frontend/GenerateQuestion/ReadingGenerateQuestions';
import StudentDashboard from './Frontend/StudentDashbaord/StudentDashboard';
import AddQuestionBooks from './Frontend/AddQuestions/AddQuestionBooks';
import MathQuestionAdd from './Frontend/AddQuestions/MathQuestionAdd';
import ReadingQuestiionAdd from './Frontend/AddQuestions/ReadingQuestiionAdd';
import ThinkingSkillQuestionAdd from './Frontend/AddQuestions/ThinkingSkillQuestionAdd';
import WritingQuestionAdd from './Frontend/AddQuestions/WritingQuestionAdd';
import ImportQuestions from './Frontend/ImportQuestions/ImportQuestions';
import TestPage from './Frontend/TestPage/TestPage';
import PracticeTestPage from './Frontend/TestPage/PracticeTestPage';
import AboutUs from './Frontend/AboutUs/AboutUs';
import ContactUs from './Frontend/ContactUs/ContactUs';
import FAQSection from './Frontend/FAQs/FAQs';
import Pricing from './Frontend/Pricing/Pricing';
import ScrollToTop from './Frontend/Context/ScrollToTop';
import NewStudentDashboard from './Frontend/NewStudentDashboard/NewStudentDashboard';
import WeeklyExamPage from './Frontend/TestPage/WeeklyExamPage';
import ManageStudentAccess from './Frontend/AdminDashboard/ManageStudentAccess';
import TopicSelectionPage from './Frontend/NewStudentDashboard/TopicSelectionPage';
import TopicTestPage from './Frontend/NewStudentDashboard/TopicTestPage';
import ProfilePage from './Frontend/ProfilePage/ProfilePage';
import PaymentSuccess from './Frontend/NewStudentDashboard/PaymentSuccess';
import TestResultPage from './Frontend/TestResultPage/TestResultPage';
import TestHistoryPage from './Frontend/TestResultPage/TestHistoryPage';
import ExamSelection from './Frontend/FreeAssesment/ExamSelection';
import PremiumTestsPage from './Frontend/NewStudentDashboard/PremiumTestsPage';
import SubjectTestsPage from './Frontend/NewStudentDashboard/SubjectTestsPage';
import OCJourney from './Frontend/OC_Journey/ocJourney';
import WhatWeDo from './Frontend/ContactUs/Whatwedo';
import SelectiveJourney from './Frontend/OC_Journey/selectiveJOurney';
import EmailConfirmation from './Frontend/FreeAssesment/EmailConfirmation';
import TermsPage from './Frontend/TermsConditions/TermsCondition';
import PrivacyPolicy from './Frontend/TermsConditions/PrivacyPolicy';
import MockTestsPage from './Frontend/MockTest/MockTestsPage';
import MockTestPage from './Frontend/MockTest/MockTestPage';
import AdminWritingTests from './Frontend/AdminDashboard/AdminWritingTests';
import TeacherDashboard from './Frontend/TeacherDashboard/TeacherDashboard';
import AddTeacher from './Frontend/AdminDashboard/AddTeacher';
import WritingTestPage from './Frontend/MockTest/WritingTestPage';
import MockTest from './Frontend/NewStudentDashboard/MockTest';
import IndividualMockTests from './Frontend/NewStudentDashboard/IndividualMockTests';
import IndividualMockTestStartPage from './Frontend/NewStudentDashboard/IndividualMockTestStartPage';
import IndividualMockTestInstructionsPage from './Frontend/NewStudentDashboard/IndividualMockTestInstructionsPage';
import IndividualMockTestsPage from './Frontend/NewStudentDashboard/IndividualMockTestsPage';

function App() {
  const location = useLocation();

  // List of routes where Navbar should not be displayed
  const noNavbarRoutes = ["/questions-page/:category", "/practice-test", "/test/:testType/:category", "/topic-test/:topic", "/weekly-test", "/mock-test/:subject", "/teacher/dashboard", "/individual-mock-test-start",
  "/individual-mock-test-instructions"];

  // Determine if the current route matches any in the list
  const isNavbarHidden = noNavbarRoutes.some((route) =>
    location.pathname.startsWith(route.split(":")[0]) // Match static parts of dynamic routes
  );

  return (
    <>

      {!isNavbarHidden && <Navbar />}
      <ScrollToTop />
      <Routes>
        <Route index element={<LandingPage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faqs" element={<FAQSection />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/terms&condition" element={<TermsPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/email-confirmation" element={<EmailConfirmation />} />
        <Route path="/oc-journey" element={<OCJourney />} />
        <Route path="/selective-journey" element={<SelectiveJourney />} />
        <Route path="/what-we-do" element={<WhatWeDo />} />
        <Route path="/admin-dashboard" element={<AdminDashboard />} />
        <Route path="/student-dashboard" element={<StudentDashboard />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/test/:testType/:category" element={<TestPage />} />
        <Route path="/practice-test" element={<PracticeTestPage />} />
        <Route path="/select_question/:subject" element={<SelectQuestionPage />} />
        <Route path="/freeassesment" element={<FreeAssesment />} />
        <Route path="/exam-selection" element={<ExamSelection />} />
        <Route path="/premium-tests" element={<PremiumTestsPage />} />
        <Route path="/subject-tests" element={<SubjectTestsPage />} />
        <Route path="/test-assesment-books" element={<TestAssesmentBooks />} />
        <Route path="/questions-page/:category" element={<QuestionPage />} />
        <Route path="/questions/:subject" element={<SelectQuestionPage />} />
        <Route path="/view-questions/:subject" element={<ViewQuestionsPage />} />
        <Route path="/questions/:subject/:id" element={<GenerateQuestionPage />} />
        <Route path="/readingQuestion/:subject/:questionId/:extractQuestionId" element={<ReadingGenerateQuestions />} />
        <Route path="/landing" element={<LandingPage />} />
        <Route path="/free-assessment" element={<ProtectedRoute><FreeAssessment /></ProtectedRoute>} />
        <Route path='/add-questionsBooks' element={<ProtectedRoute><AddQuestionBooks /></ProtectedRoute>} />
        <Route path='/import-questions' element={<ProtectedRoute><ImportQuestions /></ProtectedRoute>} />
        <Route path='/add-mathQuestions' element={<ProtectedRoute><MathQuestionAdd /></ProtectedRoute>} />
        <Route path='/add-readingQuestions' element={<ProtectedRoute><ReadingQuestiionAdd /></ProtectedRoute>} />
        <Route path='/add-thinkingskillQuestions' element={<ProtectedRoute><ThinkingSkillQuestionAdd /></ProtectedRoute>} />
        <Route path='/add-writingQuestions' element={<ProtectedRoute><WritingQuestionAdd /></ProtectedRoute>} />
        <Route path="/manage-access" element={<ManageStudentAccess />} />
        <Route path="/new-student-dashboard" element={<NewStudentDashboard />} />
        <Route path="/weekly-test" element={<WeeklyExamPage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/maths-topics" element={<TopicSelectionPage subject="Maths" />} />
        <Route path="/topic-test/:topic" element={<TopicTestPage />} />
        <Route path="/test-results/:testType/:testId" element={<TestResultPage />} />
        <Route path="/test-history" element={<TestHistoryPage />} />
        <Route path="/coupon-management" element={<CouponManagement />} />
        <Route path="/mock-test" element={<MockTest />} />
        <Route path="/mock-tests" element={<MockTestsPage />} />
        <Route path="/mock-test/:subject" element={<MockTestPage />} />
        <Route path="/admin/writing-tests" element={<AdminWritingTests />} />
        <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
        <Route path="/admin/add-teacher" element={<AddTeacher />} />
        <Route path="/mock-test/writing" element={<WritingTestPage />} />
        <Route path="/individual-mock-tests" element={<IndividualMockTests />} />
        <Route path="/individual-mock-test-start" element={<IndividualMockTestStartPage />} />
        <Route path="/individual-mock-test-instructions" element={<IndividualMockTestInstructionsPage />} />
        <Route path="/individual-mock-test" element={<IndividualMockTestsPage />} />

      </Routes>
    </>
  );
}

export default App;
